<template>
  <div class="counselor-card__description">
    <div class="counselor-card__description-text" v-html="backgroundText" />
    <p class="counselor-card__description-action">
      <a
        class="btn n-btn inline icon-right arrow-link"
        :href="link"
      >
        {{ readMoreAbout }}
        <svg class="icon">
          <use href="#arrow-right-long" />
        </svg>
      </a>
    </p>
  </div>
</template>

<script>
import { API_ROLES } from 'Main/contact-form/constants';
import { sprintf } from 'sprintf-js';

export default {

  computed: {

    backgroundText() {
      const meta = this.counselor.meta;
      let background = '';

      if (meta) {
        for (const key in meta) {
          if (
            meta[key].key === 'background' &&
            meta[key].role === this.roleToMatch
          ) {
            background = meta[key].value;
            break;
          } else if (meta[key].key === 'background') {
            background = meta[key].value;
          }
        }
      }

      return this.stripHeadings(background || '');
    },
    defaultRole() {
      return this.counselor?.default_role || null;
    },

    firstName() {
      return this.counselor.name.split(' ')[0];
    },

    readMoreAbout() {
      return sprintf(this.counselorGridTexts.readMoreAbout, this.firstName);
    },

    roleToMatch() {
      switch (this.role) {
        case 'therapy':
          return API_ROLES.THERAPY;
        case 'lawyer':
          return API_ROLES.LAW;
        default:
          return this.defaultRole || API_ROLES.FUNERAL;
      }
    },
  },

  data() {
    return {
      counselorGridTexts: theme_vars.counselorGridTexts,
    };
  },

  methods: {
    // Headings belong on the advisor's own profile page, not in the card.
    // Convert any `<h1>`–`<h6>` to plain paragraphs (keeping inline
    // formatting such as bold/italic) so they don't render as large
    // headings in the slider/search list.
    stripHeadings(html) {
      if (!html) {
        return '';
      }

      const doc = new DOMParser().parseFromString(html, 'text/html');

      for (const heading of doc.body.querySelectorAll('h1, h2, h3, h4, h5, h6')) {
        const paragraph = doc.createElement('p');
        paragraph.innerHTML = heading.innerHTML;
        heading.replaceWith(paragraph);
      }

      return doc.body.innerHTML;
    },
  },
  name: 'CounselorDescription',

  props: {
    counselor: {
      required: true,
      type: Object,
    },
    link: {
      default: '#',
      type: String,
    },
    role: {
      default: '',
      type: String,
    },
  },
};
</script>
